import { useState } from "react";
import { saveBalanceAdjustment } from "../Api/BalanceAdjustmentAdvanceReq";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
//import "../Styling/BalanceAdjustmentAdvanceReq.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const BalanceAdjustmentAdvanceReq = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId") || "5"; 

  const [adjustmentData, setAdjustmentData] = useState({
    employeeName: "",
    totalAdvanceAmountDisbursed: "",
    totalActualExpenses: "",
    balanceAmount: "",
    adjustmentType: "",
    adjustmentDate: "",
    adjustmentMode: "",
    approvedBy: "",
    remarks: "",
    advanceReqId: "",
    createdBy: userId 
  });

  const handleChange = (e) => {
    setAdjustmentData({ ...adjustmentData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dataToSend = {
        ...adjustmentData,
        createdBy: userId
      };
      
      await saveBalanceAdjustment(dataToSend);
      toast.success(`🦄 Balance Adjustment Added Successfully`);
      setAdjustmentData({
        employeeName: "",
        totalAdvanceAmountDisbursed: "",
        totalActualExpenses: "",
        balanceAmount: "",
        adjustmentType: "",
        adjustmentDate: "",
        adjustmentMode: "",
        approvedBy: "",
        remarks: "",
        advanceReqId: "",
        createdBy: userId
      });
    } catch (error) {
      toast.error(`🦄 Some Error Happened`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Balance Adjustment Advance Request</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Employee Name <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="employeeName" 
                      value={adjustmentData.employeeName} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Total Advance Amount Disbursed <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="number" 
                      name="totalAdvanceAmountDisbursed" 
                      value={adjustmentData.totalAdvanceAmountDisbursed} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Total Actual Expenses <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="totalActualExpenses" 
                      value={adjustmentData.totalActualExpenses} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Balance Amount <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="number" 
                      name="balanceAmount" 
                      value={adjustmentData.balanceAmount} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adjustment Type <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="adjustmentType" 
                      value={adjustmentData.adjustmentType} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adjustment Date <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="date" 
                      name="adjustmentDate" 
                      value={adjustmentData.adjustmentDate} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Adjustment Mode <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="adjustmentMode" 
                      value={adjustmentData.adjustmentMode} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Approved By <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="approvedBy" 
                      value={adjustmentData.approvedBy} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="remarks" 
                      value={adjustmentData.remarks} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Advance Request ID <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="advanceReqId" 
                      value={adjustmentData.advanceReqId} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Adjustment
                </Button>
              </div>
            </Form>
          </Container>
        </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default BalanceAdjustmentAdvanceReq;